import { EVENT_FORM_UPDATE } from '../../actions/eventForm';
import { POST_EVENT } from '../../actions/events';

const initialState = {
  description: "",
  color: '#B80000',
  posting: false,
  errors: []
}

const eventForm = (state = initialState, action) => {
  switch(action.type) {
    case EVENT_FORM_UPDATE:
      return { ...state, ...action.payload };
    case `${POST_EVENT}_PENDING`:
      return { ...state, posting: true}
    case `${POST_EVENT}_FULFILLED`:
      return initialState;
    case `${POST_EVENT}_REJECTED`:
      return { ...state, posting: false, errors: ['Great failure']}
    default:
      return state;
  }
}

export default eventForm;



// WEBPACK FOOTER //
// ./src/reducers/ui/eventForm.js